import { render, staticRenderFns } from "./Sign.vue?vue&type=template&id=0aaed52c&scoped=true"
import script from "./Sign.vue?vue&type=script&lang=js"
export * from "./Sign.vue?vue&type=script&lang=js"
import style0 from "./Sign.vue?vue&type=style&index=0&id=0aaed52c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0aaed52c",
  null
  
)

export default component.exports